import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import ProtectedRouteV2 from './ProtectedRouteV2';

import RealtimeChannelsPage from '../pages/Realtime/RealtimeChannelsPage';
import RealtimeSubscriptionsPage from '../pages/Realtime/RealtimeSubscriptionsPage';
import RealtimeMonitorPage from '../pages/Realtime/RealtimeMonitorPage';

const realtimeRoutes = (
  <Route element={<ProtectedRouteV2 />}>

    <Route
      path="/settings/realtime/channels"
      element={
        <>
          <PageTitle title="Canales | Codenova POS" />
          <RealtimeChannelsPage />
        </>
      }
    />

    <Route
      path="/settings/realtime/subscriptions"
      element={
        <>
          <PageTitle title="Suscripciones | Codenova POS" />
          <RealtimeSubscriptionsPage />
        </>
      }
    />

    <Route
      path="/settings/realtime/monitor"
      element={
        <>
          <PageTitle title="Monitor | Codenova POS" />
          <RealtimeMonitorPage />
        </>
      }
    />

  </Route>
);

export default realtimeRoutes;